import { CurrencyPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { Currency, SubscriptionPeriod } from '../../../../../../common/dto/subscription.dto';
import { PillComponent } from '../../components/pill/pill.component';

@Component({
  selector: 'app-pricing-sub',
  imports: [
    CurrencyPipe,
    PillComponent,
    MatButton,
    FaIconComponent,
  ],
  templateUrl: './pricing-sub.component.html',
  styleUrl: './pricing-sub.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PricingSubComponent {
  public name = input.required<string>();

  public letsTalk = input(false);

  public price = input<number>(0);
  public currency = input.required<Currency>();
  public period = input.required<SubscriptionPeriod>();

  public hideCTA = input(false);
  public ctaText = input<string>($localize`Subscribe`);
  public ctaClicked = output();
  public letsTalkClicked = output();

  public featuresTitle = input.required<string>();
  public features = input.required<string[]>();

  protected readonly faCheck = faCheck;
}
